module.exports = __webpack_public_path__ + "static/img/Carbono Neutralidad.40f2c6c2.png";